import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Dash } from '../pages/admin/dash';
import { AllServices } from '../pages/admin/allservices';
import { AddService } from '../pages/admin/addservice';
import { UpdateService } from '../pages/admin/updateservice';
import { AllTestimonials } from '../pages/admin/alltestimonials';
import { AllContacts } from '../pages/admin/allcontacts';
import { AllMetadata } from '../pages/admin/allmetadatas';
import { UpdateMetaData } from '../pages/admin/updatemetadata';
import { AllClients } from '../pages/admin/allclients';
import { AddClient } from '../pages/admin/addClient';
import { UpdateClient } from '../pages/admin/updateclient';
import { AllTeam } from '../pages/admin/allteam';
import { AddTeam } from '../pages/admin/addteam';
import { UpdateTeam } from '../pages/admin/updateteam';
import { AllBanners } from '../pages/admin/allbanners';
import { AddBanner } from '../pages/admin/addbanner';
import { UpdateBanner } from '../pages/admin/updatebanners';
import { EditFeedback } from '../pages/admin/editfeedback';
import { UpdateAboutUs } from '../pages/admin/updateaboutus';
import { AddArticle } from '../pages/admin/addArticle';
import { EditArticle } from '../pages/admin/EditArticle';
import { AllArticles } from '../pages/admin/allArtcles';
import { EnrolledStudents } from '../pages/admin/enrolled_students';
import { UpdateArticle } from '../pages/admin/updatearticle';
import { Blogs } from '../pages/admin/Blogs';
import { AllArticlesList } from '../pages/admin/allarticles';
import { AllTests } from '../pages/admin/alltests';

export const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Dash />} />
      <Route path="/enrolled_students" element={<EnrolledStudents />} />
      <Route path="/allcontacts" element={<AllContacts />} />
      <Route path="/allservices" element={<AllServices />} />
      <Route path="/addservice" element={<AddService />} />
      <Route path="/updateservice/:id" element={<UpdateService />} />
      <Route path="/alltestimonials" element={<AllTestimonials />} />
      <Route path="/allmetadatas" element={<AllMetadata />} />
      <Route path="/updatemetadata/:id" element={<UpdateMetaData />} />
      <Route path="/allclients" element={<AllClients />} />
      <Route path="/addclient" element={<AddClient />} />
      <Route path="/updateclient/:id" element={<UpdateClient />} />
      <Route path="/allteam" element={<AllTeam />} />
      <Route path="/addteam" element={<AddTeam />} />
      <Route path="/updateteam/:id" element={<UpdateTeam />} />
      <Route path="/allbanners" element={<AllBanners />} />
      <Route path="/addbanner" element={<AddBanner />} />
      <Route path="/updatebanner/:id" element={<UpdateBanner />} />
      <Route path="/editfeedback" element={<EditFeedback />} />
      <Route path="/updateaboutus" element={<UpdateAboutUs />} />
      <Route path="/addarticle" element={<AddArticle />} />
      <Route path="/editarticle/:id" element={<EditArticle />} />
      <Route path="/allarticles" element={<AllArticles />} />
      <Route path="/updatearticle/:id" element={<UpdateArticle />} />
      <Route path="/blogs" element={<Blogs />} />
      <Route path="/allarticleslist" element={<AllArticlesList />} />
      <Route path="/alltests" element={<AllTests />} />
    </Routes>
  );
};
